import * as angular from 'angular';
import { DynamicCompileService } from './services/dynamicCompileService';
import { WtBackgroundOverlay } from './directives/wtBackgroundOverlay';
import { WtDependencies } from './directives/wtDependencies';
import { BulletChartDirective } from './directives/charts/bulletChartDirective';
import { MultiBulletChartDirective as MultiBulletChartDirective } from './directives/charts/multiBulletChartDirective';
import { CategoricalChartDirective as CategoricalChartDirective } from './directives/charts/categoricalChartDirective';
// import { gaugeDirective } from './directives/charts/gaugeDirective';
import { HorizontalBarChartDirective as HorizontalBarChartDirective } from './directives/charts/horizontalBarChartDirective';
import { LineChartDirective } from './directives/charts/lineChartDirective';
import { RangeChartDirective } from './directives/charts/rangeChartDirective';
import { ScatterPlotDirective } from './directives/charts/scatterPlotDirective';
import { StatusChartDirective } from './directives/charts/statusChartDirective';
import { StackedAreaChartDirective } from './directives/charts/stackedAreaChartDirective';

import { wtDoughnutChart } from './components/doughnutChart/doughnutChart.component';
import { wtHorizontalCategoricalChart } from './components/horizontalCategoricalChart/horizontalCategoricalChart.component';

import { WtDateTimePicker } from './directives/dateTimePicker/wtDateTimePicker';
import { DateTimePicker } from './directives/dateTimePicker/DateTimePicker';
import { wtNewGauge } from './components/gauge/gauge.component';

export const name = 'wt-framework';

const app = angular.module(name, []);

app.factory('dynamicCompileService', [
    '$compile', '$timeout',
    ($c, $t) => new DynamicCompileService($c, $t)
]);

app
    .directive(WtBackgroundOverlay.directiveId, [
        'dynamicCompileService', (dynamicCompileService) =>
            new WtBackgroundOverlay(dynamicCompileService)
    ])
    .directive(WtDependencies.directiveId, [
        'dynamicCompileService', (dynamicCompileService) =>
            new WtDependencies(dynamicCompileService)
    ])
    .directive(WtDateTimePicker.directiveId, [
        '$window', ($window) =>
            new WtDateTimePicker($window)
    ]);
app.directive(BulletChartDirective.directiveId, [() => new BulletChartDirective()]);
app.directive(MultiBulletChartDirective.directiveId,
    ['dynamicCompileService', (dynamicCompileService) => new MultiBulletChartDirective(dynamicCompileService)]);
app.directive(CategoricalChartDirective.directiveId, [
    'dynamicCompileService', (dynamicCompileService) =>
        new CategoricalChartDirective(dynamicCompileService)
]);
// app.directive(gaugeDirective.directiveId, [
//     '$window', $window =>
//         new gaugeDirective($window)
// ]);
app.directive(HorizontalBarChartDirective.directiveId, [
    () =>
        new HorizontalBarChartDirective()
])
    .directive(LineChartDirective.directiveId, [
        'dynamicCompileService', (dynamicCompileService) =>
            new LineChartDirective(dynamicCompileService)
    ])
    .directive(RangeChartDirective.directiveId, [
        () =>
            new RangeChartDirective()
    ])
    .directive(ScatterPlotDirective.directiveId, [
        'dynamicCompileService',
        (dynamicCompileService) =>
            new ScatterPlotDirective(dynamicCompileService)
    ]);

app.directive(StackedAreaChartDirective.directiveId, [() => new StackedAreaChartDirective()])
   .directive(StatusChartDirective.directiveId, [ 'dynamicCompileService', (dcs) => new StatusChartDirective(dcs) ]);
app.controller(DateTimePicker.controllerId, DateTimePicker);
app.component(wtDoughnutChart.componentId, wtDoughnutChart)
   .component(wtHorizontalCategoricalChart.componentId, wtHorizontalCategoricalChart)
   .component(wtNewGauge.componentId, wtNewGauge)
   ;

export const module = app;